import baseMessages from './en.allianzcee.easyclaim';

const messages: Record<string, string> = {
	...baseMessages,
	'onboarding.terms.url':
		'By continuing, you confirm that you have read and understood the <tclink>Privacy Policy</tclink>.',
};

export default messages;
